'use es6';

import { combineReducers } from 'redux';
import { SHARED_DND_UPDATE_CONTEXT_MONITOR } from 'DesignData/actions/ActionTypes';
/**
 * Current monitor values from the SharedDragDropContext
 */

function monitor(state = {
  isDragging: false,
  itemType: null,
  item: null
}, action) {
  switch (action.type) {
    case SHARED_DND_UPDATE_CONTEXT_MONITOR:
      {
        const {
          isDragging,
          itemType,
          item
        } = action;
        return {
          isDragging,
          itemType,
          item
        };
      }

    default:
      return state;
  }
}

export default combineReducers({
  monitor
});